export default function isNegative(value) {
    return value < 0;
}
